import React from 'react';
import { formatPrice } from '../../utils';
import './PricingStep.css';

const SUGGESTIONS = [-0.05, -0.02, 0, 0.02];

export default function PricingStep({ wiz, property }) {
  const list = property?.price || property?.list_price || 0;
  const offer = wiz.derived.offerPrice;
  const deltaPct = wiz.derived.deltaPct;
  const delta = wiz.derived.deltaVsList;

  let tone = 'neutral';
  let label = 'Matches asking price';
  if (offer > 0 && list > 0) {
    if (deltaPct > 0.01) {
      tone = 'high';
      label = `${deltaPct.toFixed(1)}% above asking`;
    } else if (deltaPct < -0.01) {
      tone = 'low';
      label = `${Math.abs(deltaPct).toFixed(1)}% below asking`;
    }
  }

  const handlePrice = (e) => {
    const raw = e.target.value.replace(/[^0-9]/g, '');
    wiz.setField('offer_price', raw ? parseInt(raw, 10) : 0);
  };

  return (
    <section className="pricing-step">
      <header className="pricing-step__intro">
        <h3>What is your offer price?</h3>
        <p>
          The asking price is <strong>{formatPrice(list)}</strong>. You can offer above, below, or at the asking price.
        </p>
      </header>

      <div className="pricing-step__field">
        <label htmlFor="pricing-step-price" className="pricing-step__label">Offer price</label>
        <div className="pricing-step__input-wrap">
          <span className="pricing-step__prefix" aria-hidden="true">$</span>
          <input
            id="pricing-step-price"
            type="text"
            inputMode="numeric"
            className="pricing-step__input"
            value={offer ? offer.toLocaleString('en-US') : ''}
            onChange={handlePrice}
            placeholder={list ? list.toLocaleString('en-US') : '450,000'}
            required
            autoFocus
          />
        </div>
        {offer > 0 && list > 0 && (
          <div className={`pricing-step__feedback pricing-step__feedback--${tone}`}>
            <span className="pricing-step__pill">{label}</span>
            {Math.abs(delta) >= 1 && (
              <span className="pricing-step__delta">
                {`${delta < 0 ? '−' : '+'}${formatPrice(Math.abs(delta))} vs asking`}
              </span>
            )}
          </div>
        )}
        <p className="pricing-step__hint">
          Tip: a strong opener is competitive but leaves room to negotiate. Typical range is ±5% of the asking price.
        </p>
      </div>

      {list > 0 && (
        <div className="pricing-step__suggestions">
          <span className="pricing-step__suggestions-label">Quick suggestions</span>
          <div className="pricing-step__chips">
            {SUGGESTIONS.map((pct) => {
              const value = Math.round(list * (1 + pct));
              const labelText = pct === 0 ? 'Asking' : `${pct > 0 ? '+' : ''}${(pct * 100).toFixed(0)}%`;
              const active = offer === value;
              return (
                <button
                  key={pct}
                  type="button"
                  className={`pricing-step__chip${active ? ' pricing-step__chip--active' : ''}`}
                  onClick={() => wiz.setField('offer_price', value)}
                >
                  <span className="pricing-step__chip-label">{labelText}</span>
                  <span className="pricing-step__chip-value">{formatPrice(value)}</span>
                </button>
              );
            })}
          </div>
        </div>
      )}
    </section>
  );
}
